// Generated by CoffeeScript 1.9.1
var MSA;
MSA = require("./msa");
module.exports = function () {
  var msa;
  msa = function msa(args) {
    return MSA.apply(this, args);
  };
  msa.prototype = MSA.prototype;
  return new msa(arguments);
};
module.exports.msa = MSA;
module.exports.model = require("./model");
module.exports.menu = require("./menu");
module.exports.utils = require("./utils");
module.exports.selection = require("./g/selection/Selection");
module.exports.selcol = require("./g/selection/SelectionCol");
module.exports.view = require("backbone-viewj");
module.exports.boneView = require("backbone-childs");
module.exports._ = require('underscore');
module.exports.$ = require('jbone');
module.exports.io = {};
module.exports.io.xhr = require('xhr');
module.exports.io.fasta = require('biojs-io-fasta');
module.exports.io.clustal = require('biojs-io-clustal');
module.exports.io.gff = require('biojs-io-gff');
module.exports.version = "0.2.0";